export default {
  name: "navTab",
  computed: {
    list() {
      let list = this.$store.getters.navTab
      return list
    },
    isActive() {
      const route = this.$route
      const {path} = route
      let menu = ''
      let obj = route.matched.find(item => {
        return !!item.meta.activeNav
      })
      if (obj) {
        menu = obj.meta.activeNav
      } else {
        menu = path
      }
      return menu
    }
  },
  methods: {
    handleClose: function (tag) {
      let index = this.list.indexOf(tag)
      this.$store.dispatch('navTab/closeNavTab', index);
    }
    ,
    handleSelectRoute: function (tag) {
      let path = tag.meta.activeNav || tag.name
      this.$router.replace({
        name: path,
        params:{
          source:'tab'
        }
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout/navTab/navTab.js